import React, { useState, useContext, useEffect } from 'react'
/* Mattlib */
import Dropdown from './Dropdown';
import RadioButtonsGroup from './RadioButtonsGroup'
import TextFields_Outlined from './TextFields_Outlined';
import ProgressBar from './ProgressBar';
import Modal_Loading from './Modal_Loading'
/* Button */
import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

/* Fade in */
import FadeIn from './FadeIn'
/* Date Picker 
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";*/
/* Data JSON */
import languages from '../data/languages.json'
import schools from '../data/schools.json'
import districts from '../data/districts.json'

import ColumnStatus from './ColumnStatus'

import ContentContext from './ContentContext'

import { useDispatch, useSelector } from 'react-redux'
import {backToInitialValuesUpdated} from '../redux/slices/translationSlice'
import {backToInitialValuesUpdated_int} from '../redux/slices/interpretationSlice'
import {backToInitialValuesUpdated_bil} from '../redux/slices/assessmentSlice'
/* Bootstrap */
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import 'bootstrap/dist/css/bootstrap.min.css';
import CustomizedSnackbars from './CustomizedSnackbars';

import SignatureUpload from './SignatureUpload'

import axios from 'axios'

// Context
import { useTranslation, useTranslationUpdate} from './TranslationContexts/TranslationDataContext'
import { SchoolOutlined } from '@material-ui/icons';

const ApprovalContent = ({ handleProgressBarChange, handleContinueButton }) => {
  const { contentState, setContentState } = useContext(ContentContext)
  const [canProceed, setCanProceed] = useState(false);
  const [column1Complete, setColumn1Complete] = useState(false)
  const [docToTranslateFiles, setDocToTranslateFiles] = useState([])

  const dispatch = useDispatch();
  const translationState = useSelector((state) => state.translation);
  const interpretationState = useSelector((state) => state.interpretation);
  const assessmentState = useSelector((state) => state.assessment);

  
  const dataForQB = useTranslation()
  const setDataForQB = useTranslationUpdate()
  var jsonPOSTdata = null;
  var ridDOdata = {
    "from": "bq35h7zek",
    "select": [
      3
    ],
    "where": "{3.GT.'0'}",
    "sortBy": [
      {
        "fieldId": 3,
        "order": "DESC"
      }
    ],
    "groupBy": [
      {
        "fieldId": 3,
        "grouping": "equal-values"
      }
    ],
    "options": {
      "skip": 0,
      "top": 0,
      "compareWithAppLocalTime": false
    }
  }
  var testPostData = null;
  var districtId = 0;
  var schoolId = 0;
  var studentDistrictId = 0;

  // These are for the loading snack
  const [showLoadingModal, setShowLoadingModal] = useState(false);
  const [loadingSnack, setLoadingSnack] = useState(false);
  const [loadingSnackClass, setLoadingSnackClass] = useState("success");

  /*const updateDocsInChild = (newFiles)=>{
    setDocToTranslateFile(newFiles)
    console.log("***updateDocsInChild - ApprovalContent.js")
  }*/

  const handleThisContinueButton = function (newState) {
    handleContinueButton(newState)
  }

  function getJsonValueByName(jsonData, name){
    let valToReturn = "0";
    let l = Object.keys(jsonData).length;
    for (var i = 0; i < l; i++) {
      
      if (name == jsonData[i].name)
      {
        valToReturn = jsonData[i].id//.toString();
        //console.log("FOUND " + name + " = " + jsonData[i].id)
        break;
      }
      //else console.log(name + " NO MATCH " + jsonData[i].name)
    }
    return valToReturn
  }

  async function finalizeJSONAndCallAPS() {
    // Convert strings to their QB rids
    districtId = getJsonValueByName(districts, translationState.districtDropdown)
    schoolId = getJsonValueByName(schools, translationState.schoolDropdown)
    studentDistrictId = getJsonValueByName(districts, translationState.studentDistrictDropdown)

    // Will need to extract just the value out of this and not the entire object
    //let temp = dataForQB.dateDue.value;//.toString();
    //console.log("TEEEEEEEEEEEEEEEST: " + temp);
    dataForQB.approverSignatureFile = "";
    //console.log(intakeFile)
    var st = intakeFile.indexOf("/");
    var en = intakeFile.indexOf(";")
    var intakeFileExt = intakeFile.substring(st+1, en)
    //console.log("START: " + st + " END: " + en)
    var startIndex = intakeFile.indexOf(";base64,");
    var finalIntakeFile = intakeFile.substring(startIndex+8, intakeFile.length)
    //console.log("INTAKE FILEEEEEEE\n"+finalIntakeFile)
    var finalSignatureFile = "";
    var signatureFileExt = "";
    var signatureFileName = "";
    if (signatureFile.length>0){
      var st = signatureFile.indexOf("/");
      var en = signatureFile.indexOf(";")
      signatureFileExt = signatureFile.substring(st+1, en)
      finalSignatureFile = signatureFile.substring(startIndex+8, signatureFile.length)
      signatureFileName = "signature.";
    }
    setIntakeFile(finalIntakeFile);
    //setIntakeFile(btoa('iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4//8/w38GIAXDIBKE0DHxgljNBAAO9TXL0Y4OHwAAAABJRU5ErkJggg=='))
    console.log("FINAL DATE: " + translationState.dueDateText)
    jsonPOSTdata = {
      "to": "bq35h7zek",
      "data": [
        {
          "6": { "value": translationState.iep_checked },
          "7": { "value": translationState.iepText },
          "8": { "value": translationState.transcript_checked },
          "9": { "value": translationState.transcriptText },
          "10": { "value": translationState.letter_checked },
          "11": { "value": translationState.letterText },
          "12": { "value": translationState.schoolDocument_checked },
          "278": { "value": translationState.schoolDocumentText },
          "13": { "value": translationState.calendar_checked },
          "14": { "value": translationState.calendarText },
          "15": { "value": translationState.flyerText },
          "16": { "value": translationState.flyer_checked },
          "17": { "value": translationState.handbookText },
          "18": { "value": translationState.handbook_checked },
          "19": { "value": translationState.healthFormsText },
          "20": { "value": translationState.healthForms_checked },
          "21": { "value": translationState.permissionSlipText },
          "22": { "value": translationState.permissionSlip_checked },
          "23": { "value": translationState.schedulesText },
          "24": { "value": translationState.schedules_checked },
          "26": { "value": translationState.evaluationsText },
          "25": { "value": translationState.evaluations_checked },
          "27": { "value": translationState.psychological_checked },
          "28": { "value": translationState.educational_checked },
          "29": { "value": translationState.socialHistory_checked },
          "30": { "value": translationState.speechLanguage_checked },
          "31": { "value": translationState.other_checked },
          "32": { "value": translationState.otherText },
          "270": { "value": translationState.coser },
          "284": { "value": studentDistrictId },

          "50": { "value": translationState.dueDateText },
          "33": { "value": districtId},
          "35": { "value": schoolId },
          "37": { "value": translationState.languageDropdown },
          "106": { "value": translationState.otherLanguageText },
          "38": { "value": translationState.contactNameText },
          "39": { "value": translationState.contactPhoneText },
          "40": { "value": translationState.contactEmailText },
          "41": { "value": translationState.approverNameText },
          "42": { "value": translationState.approverPositionText },
          "44": { "value": translationState.approverEmailText },
          "249": { "value": translationState.districtNotesText },
          "52": { "value": {
            "fileName": "empty.png",
            "data": ""
            }
          },
          "68": { "value": {
            "fileName": "empty.png",
            "data": ""
            }
          },
          "69": { "value": {
            "fileName": "empty.png",
            "data": ""
            }
          },
          "70": { "value": {
            "fileName": "empty.png",
            "data": ""
            }
          },
          "71": { "value": {
            "fileName": "empty.png",
            "data": ""
            }
          },
          "149": { "value": {
            "fileName": "empty.png",
            "data": ""
            }
          },
          "150": { "value": {
            "fileName": "empty.png",
            "data": ""
            }
          },
          "151": { "value": {
            "fileName": "empty.png",
            "data": ""
            }
          },
          "152": { "value": {
            "fileName": "empty.png",
            "data": ""
            }
          },
          "153": { "value": {
            "fileName": "empty.png",
            "data": ""
            }
          }
        }
      ],
      "fieldsToReturn": [
        3,
        4
      ]
    }

    console.log(jsonPOSTdata);
    //return;

    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // Add up to 10 file attachment fields

    // Get prefix for file attachment names
    let NEXT_RID_CALL = "0"
    try{NEXT_RID_CALL = await axios.post(
      'https://api.quickbase.com/v1/records/query',
      ridDOdata,
      {
        headers: {
          'QB-Realm-Hostname': 'nassauboces.quickbase.com',
          'Authorization': 'QB-USER-TOKEN b3m32i_br69_0_c89ecind3d9jnncsv8a38b7gj33s'
        }
      }
    ).then((response) => {
      return response.data.data[0][3].value;
    }, (error) => {
      return "errorFetchingRID";
    });
    }
    catch{}
    let NEXT_RID = parseInt(NEXT_RID_CALL)+1;
    let offset = 0;
    const currDate = new Date();
    if (currDate.getMonth()>5) offset = 1;
    const CURR_YR = (parseInt(new Date().getFullYear().toString().substring(2,4))+offset).toString();
    const FILE_PREFIX = CURR_YR + "-" + NEXT_RID + "T-";

    // Doc 1 //
    if (docToTranslateFiles.length>0){
      var st = docToTranslateFiles[0].content.indexOf("/");
      var en = docToTranslateFiles[0].content.indexOf(";");
      var startIndex = docToTranslateFiles[0].content.indexOf(";base64,");
      let tempFile = docToTranslateFiles[0].content.substring(startIndex+8, docToTranslateFiles[0].content.length)
      jsonPOSTdata.data[0][52].value.fileName = FILE_PREFIX + docToTranslateFiles[0].name;
      jsonPOSTdata.data[0][52].value.data = tempFile;
      console.log("TEMP FILE 1")
      console.log(tempFile)
      console.log("JSON POST 1")
      console.log(jsonPOSTdata)
    }

    // Doc 2 //
    if (docToTranslateFiles.length>1){
      var st = docToTranslateFiles[1].content.indexOf("/");
      var en = docToTranslateFiles[1].content.indexOf(";");
      var startIndex = docToTranslateFiles[1].content.indexOf(";base64,");
      let tempFile = docToTranslateFiles[1].content.substring(startIndex+8, docToTranslateFiles[1].content.length)
      jsonPOSTdata.data[0][68].value.fileName = FILE_PREFIX + docToTranslateFiles[1].name;
      jsonPOSTdata.data[0][68].value.data = tempFile;
      console.log("TEMP FILE 2")
      console.log(tempFile)
      console.log("JSON POST 2")
      console.log(jsonPOSTdata)
    }
    else{
      delete jsonPOSTdata.data[0][68];
    }

    // Doc 3 //
    if (docToTranslateFiles.length>2){
      var st = docToTranslateFiles[2].content.indexOf("/");
      var en = docToTranslateFiles[2].content.indexOf(";");
      var startIndex = docToTranslateFiles[2].content.indexOf(";base64,");
      let tempFile = docToTranslateFiles[2].content.substring(startIndex+8, docToTranslateFiles[2].content.length)
      jsonPOSTdata.data[0][69].value.fileName = FILE_PREFIX + docToTranslateFiles[2].name;
      jsonPOSTdata.data[0][69].value.data = tempFile;
      console.log("TEMP FILE 3")
      console.log(tempFile)
      console.log("JSON POST 3")
      console.log(jsonPOSTdata)
    }
    else{
      delete jsonPOSTdata.data[0][69];
    }

    // Doc 4 //
    if (docToTranslateFiles.length>3){
      var st = docToTranslateFiles[3].content.indexOf("/");
      var en = docToTranslateFiles[3].content.indexOf(";");
      var startIndex = docToTranslateFiles[3].content.indexOf(";base64,");
      let tempFile = docToTranslateFiles[3].content.substring(startIndex+8, docToTranslateFiles[3].content.length)
      jsonPOSTdata.data[0][70].value.fileName = FILE_PREFIX + docToTranslateFiles[3].name;
      jsonPOSTdata.data[0][70].value.data = tempFile;
    }
    else{
      delete jsonPOSTdata.data[0][70];
    }

    // Doc 5 //
    if (docToTranslateFiles.length>4){
      var st = docToTranslateFiles[4].content.indexOf("/");
      var en = docToTranslateFiles[4].content.indexOf(";");
      var startIndex = docToTranslateFiles[4].content.indexOf(";base64,");
      let tempFile = docToTranslateFiles[4].content.substring(startIndex+8, docToTranslateFiles[4].content.length)
      jsonPOSTdata.data[0][71].value.fileName = FILE_PREFIX + docToTranslateFiles[4].name;
      jsonPOSTdata.data[0][71].value.data = tempFile;
    }
    else{
      delete jsonPOSTdata.data[0][71];
    }

    // Doc 6 //
    if (docToTranslateFiles.length>5){
      var st = docToTranslateFiles[5].content.indexOf("/");
      var en = docToTranslateFiles[5].content.indexOf(";");
      var startIndex = docToTranslateFiles[5].content.indexOf(";base64,");
      let tempFile = docToTranslateFiles[5].content.substring(startIndex+8, docToTranslateFiles[5].content.length)
      jsonPOSTdata.data[0][149].value.fileName = FILE_PREFIX + docToTranslateFiles[5].name;
      jsonPOSTdata.data[0][149].value.data = tempFile;
    }
    else{
      delete jsonPOSTdata.data[0][149];
    }

    // Doc 7 //
    if (docToTranslateFiles.length>6){
      var st = docToTranslateFiles[6].content.indexOf("/");
      var en = docToTranslateFiles[6].content.indexOf(";");
      var startIndex = docToTranslateFiles[6].content.indexOf(";base64,");
      let tempFile = docToTranslateFiles[6].content.substring(startIndex+8, docToTranslateFiles[6].content.length)
      jsonPOSTdata.data[0][150].value.fileName = FILE_PREFIX + docToTranslateFiles[6].name;
      jsonPOSTdata.data[0][150].value.data = tempFile;
    }
    else{
      delete jsonPOSTdata.data[0][150];
    }

    // Doc 8 //
    if (docToTranslateFiles.length>7){
      var st = docToTranslateFiles[7].content.indexOf("/");
      var en = docToTranslateFiles[7].content.indexOf(";");
      var startIndex = docToTranslateFiles[7].content.indexOf(";base64,");
      let tempFile = docToTranslateFiles[7].content.substring(startIndex+8, docToTranslateFiles[7].content.length)
      jsonPOSTdata.data[0][151].value.fileName = FILE_PREFIX + docToTranslateFiles[7].name;
      jsonPOSTdata.data[0][151].value.data = tempFile;
    }
    else{
      delete jsonPOSTdata.data[0][151];
    }

    // Doc 9 //
    if (docToTranslateFiles.length>8){
      var st = docToTranslateFiles[8].content.indexOf("/");
      var en = docToTranslateFiles[8].content.indexOf(";");
      var startIndex = docToTranslateFiles[8].content.indexOf(";base64,");
      let tempFile = docToTranslateFiles[8].content.substring(startIndex+8, docToTranslateFiles[8].content.length)
      jsonPOSTdata.data[0][152].value.fileName = FILE_PREFIX + docToTranslateFiles[8].name;
      jsonPOSTdata.data[0][152].value.data = tempFile;
    }
    else{
      delete jsonPOSTdata.data[0][152];
    }

    // Doc 10 //
    if (docToTranslateFiles.length>9){
      var st = docToTranslateFiles[9].content.indexOf("/");
      var en = docToTranslateFiles[9].content.indexOf(";");
      var startIndex = docToTranslateFiles[9].content.indexOf(";base64,");
      let tempFile = docToTranslateFiles[9].content.substring(startIndex+8, docToTranslateFiles[9].content.length)
      jsonPOSTdata.data[0][153].value.fileName = FILE_PREFIX + docToTranslateFiles[9].name;
      jsonPOSTdata.data[0][153].value.data = tempFile;
    }
    else{
      delete jsonPOSTdata.data[0][153];
    }
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // Send the data
    getDataAxios();

  }
  



  // Files fields
  const [intakeFile, setIntakeFile] = useState('')
  const [signatureFile, setSignatureFile] = useState('')

  const updateColumn1Count = (valueInInput) => {
    //alert("props.triggerUpdateFromParent/updateColumn1Count val: " + valueInInput)
    setDocToTranslateFiles(valueInInput);
    dataForQB.docToTranslateFiles = valueInInput;
    //setIntakeFile(valueInInput) // <------------------------------------------ needs to be reworked
    //alert("INTAKE FILE AFTER SET: " + intakeFile)
    if (dataForQB.docToTranslateFiles.length > 0) setColumn1Complete(true)
    else setColumn1Complete(false)
    //alert("COL 1 COMPLETE AFTER SET: " + column1Complete)

    setProgressBarDataInParent();
  }

  const setProgressBarDataInParent = () => {
    let temp = 0;
    //alert(intakeFile)
    // Col 1
    if (dataForQB.docToTranslateFiles.length > 0) temp += 100;
    //alert("SET PROGESS BAR DATA IN PARENT TEMP: " + temp)
    handleProgressBarChange(parseInt(temp))
  }

  
  function backToPreviousScreen(){
    dataForQB.translationRunOnce = false
    handleThisContinueButton("main")
  }


  useEffect(() => {
    const timer = setTimeout(() => {
      setProgressBarDataInParent();
      console.log(column1Complete);
    }, 100);
    return () => clearTimeout(timer);
  }, [column1Complete]);


  const renderColumn1ColumnStatus = () => {
    return <ColumnStatus complete={column1Complete} />
  }

  function resetJSON(){
    dataForQB.translationTypes = [];
    dataForQB.iepText = '';
    dataForQB.iep_checked = '';
    dataForQB.transcriptText = '';
    dataForQB.transcript_checked = '';
    dataForQB.letterText = '';
    dataForQB.letter_checked = '';
    dataForQB.schoolDocumentText = '';
    dataForQB.schoolDocument_checked = '';
    dataForQB.calendarText = '';
    dataForQB.calendar_checked = '';
    dataForQB.flyerText = '';
    dataForQB.flyer_checked = '';
    dataForQB.handbookText = '';
    dataForQB.handbook_checked = '';
    dataForQB.healthFormsText = '';
    dataForQB.healthForms_checked = '';
    dataForQB.permissionSlipText = '';
    dataForQB.permissionSlip_checked = '';
    dataForQB.schedulesText = '';
    dataForQB.schedules_checked = '';
    dataForQB.evaluationsText = '';
    dataForQB.evaluations_checked = '';
    dataForQB.psychological_checked = '';
    dataForQB.educational_checked = '';
    dataForQB.socialHistory_checked = '';
    dataForQB.speechLanguage_checked = '';
    dataForQB.otherLanguageText = '';
    dataForQB.other_checked = '';
    dataForQB.otherText = '';
    dataForQB.dueDateText = '';
    dataForQB.districtDropdown = '';
    dataForQB.districtRid = 0;
    dataForQB.schoolDropdown = '';
    dataForQB.schoolRid = 0;
    dataForQB.languageDropdown = '';
    dataForQB.contactNameText = '';
    dataForQB.contactPhoneText = '';
    dataForQB.contactEmailText = '';
    dataForQB.approverNameText = '';
    dataForQB.approverPositionText = '';
    dataForQB.approverEmailText = '';
    dataForQB.districtNotes = '';
    dataForQB.intakeRunOnce = false;
    dataForQB.dueDate_int = '';
    dataForQB.dueTime_int = '';
    dataForQB.interpretationTypes_int = [];
    dataForQB.estimatedDurationHrs_int = '';
    dataForQB.estimatedDurationMins_int = '';
    dataForQB.paperWorkChecked_int = '';
    dataForQB.needInterpreterChecked_int = '';
    dataForQB.onlineOrVirtChecked_int = '';
    dataForQB.onlineMeetingLink_int = '';
    dataForQB.inPersonMeetingChecked_int = '';
    dataForQB.studentName_int = '';
    dataForQB.phone_int = '';
    dataForQB.grade_int = '';
    dataForQB.gender_int = '';
    dataForQB.languageDropdown_int = '';
    dataForQB.otherLanguages_int = '';
    dataForQB.districtDropdown_int = 0;
    dataForQB.schoolDropdown_int = 0;
    dataForQB.address_int = '';
    dataForQB.contactName_int = '';
    dataForQB.contactPhone_int = '';
    dataForQB.contactEmail_int = '';
    dataForQB.approverName_int = '';
    dataForQB.approverPosition_int = '';
    dataForQB.approverEmail_int = '';
    dataForQB.districtRid_int = 0;
    dataForQB.schoolRid_int = 0;
    dataForQB.approverSignatureFile_int = '';
    dataForQB.tableData_int = [];
    dataForQB.assessmentRunOnce = false;
    dataForQB.studentFirstName_bil = '';
    dataForQB.studentLastName_bil = '';
    dataForQB.countryOfOrigin_bil = '';
    dataForQB.DOB_bil = '';
    dataForQB.gender_bil = '';
    dataForQB.yearsInUS_bil = '';
    dataForQB.grade_bil = '';
    dataForQB.childResidesWith_bil = '';
    dataForQB.mfg1_bil = '';
    dataForQB.mfgName1_bil = '';
    dataForQB.mfg2_bil = '';
    dataForQB.mfgName2_bil = '';
    dataForQB.childsResidesWithOther_bil = '';
    dataForQB.homeAddress_bil = '';
    dataForQB.homeNum_bil = '';
    dataForQB.workNum_bil = '';
    dataForQB.cellNum_bil = '';
    dataForQB.nativeLanguage_bil = '';
    dataForQB.nativeLanguageOther_bil = '';
    dataForQB.districtDropdown_bil = '';
    dataForQB.schoolDropdown_bil = '';
    dataForQB.CSEDate_bil = '';
    dataForQB.psychologistName_bil = '';
    dataForQB.psychologistEmail_bil = '';
    dataForQB.speechPathologistName_bil = '';
    dataForQB.speechPathologistEmail_bil = '';
    dataForQB.districtContactName_bil = '';
    dataForQB.districtContactTitle_bil = '';
    dataForQB.districtContactAddress_bil = '';
    dataForQB.districtContactPhone_bil = '';
    dataForQB.districtContactEmail_bil = '';
    dataForQB.reason_bil = '';
    dataForQB.alreadyClassified_bil = '';
    dataForQB.classification_bil = '';
    dataForQB.consentToEvalAttached_bill = false;
    dataForQB.priorWrittenNoticeAttached_bil = false;
    dataForQB.homeLangQuestAttached_bil = false;
    dataForQB.nonVerbSecDiagnosed_bil = false;
    dataForQB.studentEnterSchoolDate_bil = '';
    dataForQB.nameOfOtherSchoolAttended_bil = '';
    dataForQB.typesOfEvals_bil = [];
    dataForQB.diagnosedCondition_bil = '';
    dataForQB.diagnosedConditionText_bil = '';
    dataForQB.services_bil = [];
    dataForQB.generalHealth_bil = false;
    dataForQB.generalHealthText_bil = '';
    dataForQB.medication_bil = false;
    dataForQB.medicationText_bil = '';
    dataForQB.wearsGlasses_bil = false;
    dataForQB.wearsGlassesText_bil = '';
    dataForQB.pedRestrictions_bil = false;
    dataForQB.pedRestrictionsText_bil = '';
    dataForQB.physicalExamDate_bil = '';
    dataForQB.h_freq_audiology_bil = '';
    dataForQB.h_indv_audiology_bil = '';
    dataForQB.h_freq_visTherapy_bil = '';
    dataForQB.h_indv_visTherapy_bil = '';
    dataForQB.h_freq_resourceRoom_bil = '';
    dataForQB.h_indv_resourceRoom_bil = '';
    dataForQB.h_freq_counseling_bil = '';
    dataForQB.h_indv_counseling_bil = '';
    dataForQB.h_freq_speechLang_bil = '';
    dataForQB.h_indv_speechLang_bil = '';
    dataForQB.h_freq_physTherapy_bil = '';
    dataForQB.h_indv_physTherapy_bil = '';
    dataForQB.h_freq_occTherapy_bil = '';
    dataForQB.h_indv_occTherapy_bil = '';
    dataForQB.i_freq_Reading_bil = '';
    dataForQB.i_indv_Reading_bil = '';
    dataForQB.i_freq_AISMath_bil = '';
    dataForQB.i_indv_AISMath_bil = '';
    dataForQB.i_freq_AAtL_bil = '';
    dataForQB.i_indv_AAtL_bil = '';
    dataForQB.i_freq_AdjAssign_bil = '';
    dataForQB.i_indv_AdjAssign_bil = '';
    dataForQB.i_freq_schedAdj_bil = '';
    dataForQB.i_indv_schedAdj_bil = '';
    dataForQB.i_freq_indvProgBasedOnSkill_bil = '';
    dataForQB.i_indv_indvProgBasedOnSkill_bil = '';
    dataForQB.i_freq_speechImprov_bil = '';
    dataForQB.i_indv_speechImprov_bil = '';
    dataForQB.i_freq_tutoring_bil = '';
    dataForQB.i_indv_tutoring_bil = '';
    dataForQB.i_freq_consulServices_bil = '';
    dataForQB.i_indv_consulServices_bil = '';
    dataForQB.i_other_bil = '';
    dataForQB.areas_bil = [];
    dataForQB.addConcerns_bil = '';
    dataForQB.suspDetails_bil = '';
    dataForQB.docToTranslateFiles = [];
    dataForQB.docToInterperateFiles_int = [];
    dataForQB.docToAccessFiles_bil = [];
    dataForQB.consentToEvalAttachedFiles_bil = [];
    dataForQB.priorWrittenNoticeAttachedFiles_bil = [];
    dataForQB.homeLangQuestAttachedFiles_bil = [];
    dataForQB.notes_int = '';
    dataForQB.notes_bil = '';
    dataForQB.approverName_bil = '';
    dataForQB.approverTitle_bil = '';
    dataForQB.approverEmail_bil = '';
    dataForQB.teleconference_int = '';
    dataForQB.teleconferencePhone_int = '';
    dataForQB.currentTeacherName_bil = '';
    dataForQB.currentTeacherEmail_bil = '';


    dispatch(backToInitialValuesUpdated(translationState.backToInitialValues+1))
    dispatch(backToInitialValuesUpdated_int(interpretationState.backToInitialValues_int+1))
    dispatch(backToInitialValuesUpdated_bil(assessmentState.backToInitialValues_bil+1))

  }


  setTimeout(function(){
    setProgressBarDataInParent();
  },300)
  //////////////////////////////////////////////////////////////

  const progressBarData =
    { bgcolor: "#00695c", completed: 0 };

  const sendDatatoQB = () => {
    //alert("WTF")
    // First we'll set any checks based on if the field has data
    finalizeJSONAndCallAPS();    
  }

  async function getDataAxios() {
      // Show loading
      setShowLoadingModal(true)
      //alert("SET SHOW LOADING MODAL")
    // POST
    const response2 = await axios.post(
      'https://api.quickbase.com/v1/records',
      jsonPOSTdata,
      {
        headers: {
          'QB-Realm-Hostname': 'nassauboces.quickbase.com',
          'Authorization': 'QB-USER-TOKEN b3m32i_br69_0_c89ecind3d9jnncsv8a38b7gj33s'
        }
      }
    )
    .then((response) => {
      //setShowLoadingModal(false)
      setLoadingSnack("Your Translation has successfully processed!")
      setLoadingSnackClass("complete")
      console.log(response);
      // Show success for 3 seconds
      setTimeout(function () {
        resetJSON();
        setShowLoadingModal(false)
        setContentState('main')

      }, 4000)
    }, (error) => {
      //setShowLoadingModal(false)
      setLoadingSnack("Sorry we are experiecing Technical Difficulties, try again later!")
      setLoadingSnackClass("error")
      // Show loading
      setShowLoadingModal(true)
      console.log("=========error===========")
      console.log(error);
      console.log("=========request===========")
      console.log(jsonPOSTdata)
      console.log("=========response==========")
      console.log(error.response)
      //alert("ERROR: " + error)
      // Show error for 3 seconds
      setTimeout(function () {
        resetJSON();
        setShowLoadingModal(false)
        setContentState('main')
      }, 5000)
    });
    
  }


  return (
    <div>
      {/*<FadeIn delay={200} duration={450}>*/}
      <Container fluid className="">
        <br/>
        <Box style={{width: '40%', backgroundColor: '#F8F8F8', padding: '3px', marginBottom: '10px'}}>
        <Card variant="outlined" style={{padding: '10px',}}>
          <CardContent>
        <Row>
          <Col>
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
              {renderColumn1ColumnStatus()}
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
          <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <h4 className="content-section-title">Translation File</h4>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
          <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <h4 className="content-section-title-sm">(Required)</h4>
            </div>
          </Col>
        </Row>
        <Row><Col><br /></Col></Row>
        <Row>
          <Col>
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
              <FadeIn delay={150} duration={450}>
                {/* Signature Upload */}
                <SignatureUpload id="formFile" classesToAdd={"required"} maxFiles={10} valueInField={dataForQB.docToTranslateFiles} triggerUpdateFromParent={updateColumn1Count} required={true} />{/* Form Upload */}
              </FadeIn>
            </div>
          </Col>
        </Row>
        <Row><Col><br /></Col></Row>
        <Row><Col><br /></Col></Row>

        </CardContent>
        </Card>
        </Box>
    <Row>
      <Col>
      <div className='form-button-bottom-container' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', width: '40%' }}>
      <Button className="btn btn-primary form-button-bottom" onClick={sendDatatoQB} disabled={!column1Complete}
          variant="contained" color="primary">
          Submit Translation
        </Button>
        </div>
      </Col>
    </Row>
      </Container>

      <div className="form-button-bottom-container">
        {/*<Button className="btn btn-primary form-button-bottom" onClick={() => backToPreviousScreen()} disabled={false}
              variant="contained" color="primary">
              Back
        </Button>
        &nbsp;&nbsp;&nbsp;&nbsp;*/}
        
      </div>

      <Modal_Loading subClass={loadingSnackClass} text={loadingSnack} show={showLoadingModal} />
      {/*</FadeIn>*/}
    </div>
  )
}

export default ApprovalContent